module.exports = __webpack_public_path__ + "static/media/icomoon.c1c8e6a3.eot";